import {Colors} from "./Colors";

export class Template {

    colors: Colors;

    constructor(colors: Colors) {
        this.colors = colors;
    }

}
